import { Select } from '@/components/ui/select';
import { TIMEFRAMES, type TimeframeKey } from '@/config/timeframes';

/**
 * Shared time-window picker for the overview. The same option set drives the
 * throughput chart, the storage-growth chart, and the job-state mix so a single
 * selection re-scopes the whole dashboard.
 */
export function TimeframeSelect({
  value,
  onChange,
  className,
}: {
  value: TimeframeKey;
  onChange: (value: TimeframeKey) => void;
  className?: string;
}) {
  return (
    <Select
      aria-label="Time window"
      className={className ?? 'h-8 w-32'}
      value={value}
      onChange={(e) => onChange(e.target.value as TimeframeKey)}
    >
      {TIMEFRAMES.map((t) => (
        <option key={t.key} value={t.key}>
          {t.label}
        </option>
      ))}
    </Select>
  );
}
